import { get, remove } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchUsers =
  ({ filtered = [] }, userType) =>
  dispatch => {
    const filters = filtered.reduce((curr, next) => {
      curr[next.id] = next.value;
      return curr;
    }, {});

    const query = {
      type: userType,
      id: filters.id,
      firstName: filters.firstName,
      lastName: filters.lastName,
      phone: filters.phone,
      email: filters.email,
      partial: false,
    };

    if (!isNaN(filters.sex)) {
      query['sex[_operator]'] = 'eq';
      query['sex[]'] = filters.sex;
    }

    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    return get('/employees', query).then(response => {
      dispatch({
        type: types.FETCH_USERS,
        payload: {
          users: response['hydra:member'],
        },
      });
      return response['hydra:member'];
    });
  };

export const fetchUser = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get(`/employees/${id}`).then(response => {
    dispatch({
      type: types.FETCH_USER,
      payload: {
        ...response,
      },
    });
    return response;
  });

export const clearUser = () => dispatch => {
  dispatch({
    type: types.CLEAR_USER,
    payload: {},
  });
};

export const removeUser = id => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  remove(`/employees/${id}`).then(() => {
    dispatch({
      type: types.REMOVE_USER,
      payload: {
        userId: id,
      },
    });
  });
